export type TwoFaScreenTranslations = {
  done: string;
  reset2faTitle: string;
  reset2faSuccessDescription: string;
  reset2faSuccessDescriptionBody: string;
  reset2faSkip: string;
  reset2faDescription: string;
  reset2faAreYouSure: string;
  reset2faSelectMethodTitle: string;
  reset2faOptionAuthenticator: string;
  reset2faOptionRecoveryCode: string;
  reset2faOptionHelpdesk: string;
  reset2faAppcodeTitle: string;
  reset2faAppcodeDescription: string;
  reset2faInvalidCode: string;
  reset2faButton: string;
  reset2faRecoveryTitle: string;
  reset2faRecoveryDescription: string;
  generalRecoveryCode: string;
  qr2faSubtitle: string;
  qr2faManualDescription: string;
  qr2faDescription: string;
  corpOnboardingEmailQTitle: string;
  authenticationText: string;
  recovery2faSubtitle: string;
  recovery2faBody: string;
  recovery2faInputfield: string;
  copy: string;
  continue: string;
  recovery2faWarning: string;
  welcome2faTitle: string;
  welcome2faSubtitle: string;
  welcome2faBody: string;
  welcome2faCtaSkip: string;
  generalErrorHeadline: string;
};

const screenTranslations: TwoFaScreenTranslations = {
  done: 'done',
  reset2faTitle: '2fa_reset_title',
  reset2faSuccessDescription: '2fa_reset_success_description',
  reset2faSuccessDescriptionBody: '2fa_reset_success_description_body',
  reset2faSkip: '2fa_reset_skip',
  reset2faDescription: '2fa_reset_description',
  reset2faAreYouSure: '2fa_reset_are_you_sure',
  reset2faSelectMethodTitle: '2fa_reset_select_method_title',
  reset2faOptionAuthenticator: '2fa_reset_option_authenticator',
  reset2faOptionRecoveryCode: '2fa_reset_option_recovery_code',
  reset2faOptionHelpdesk: '2fa_reset_option_helpdesk',
  reset2faAppcodeTitle: '2fa_reset_appcode_title',
  reset2faAppcodeDescription: '2fa_reset_appcode_description',
  reset2faInvalidCode: '2fa_reset_invalid_code',
  reset2faButton: '2fa_reset_button',
  reset2faRecoveryTitle: '2fa_reset_recovery_title',
  reset2faRecoveryDescription: '2fa_reset_recovery_description',
  generalRecoveryCode: 'general_recovery_code',
  qr2faSubtitle: '2fa_qr_subtitle',
  qr2faManualDescription: '2fa_qr_manual_description',
  qr2faDescription: '2fa_qr_description',
  corpOnboardingEmailQTitle: 'corp_onboarding_email_q_title',
  authenticationText: 'authentication_text',
  recovery2faSubtitle: '2fa_recovery_subtitle',
  recovery2faBody: '2fa_recovery_body',
  recovery2faInputfield: '2fa_recovery_inputfield',
  copy: 'copy',
  continue: 'continue',
  recovery2faWarning: '2fa_recovery_warning',
  welcome2faTitle: '2fa_welcome_title',
  welcome2faSubtitle: '2fa_welcome_subtitle',
  welcome2faBody: '2fa_welcome_body',
  welcome2faCtaSkip: '2fa_welcome_cta_skip',
  generalErrorHeadline: 'general_error_headline',
};

export const getTwoFATranslations = (
  transUtil: (param: string) => string,
): TwoFaScreenTranslations => {
  return Object.entries(screenTranslations).reduce((acc, [key, value]) => {
    acc[key as keyof TwoFaScreenTranslations] = transUtil(value);

    return acc;
  }, {} as TwoFaScreenTranslations);
};
